module.exports = __webpack_public_path__ + "static/img/zimao.3824728.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zimao.gif
// module id = DB+a
// module chunks = 1